import ClickOutside from "@/directives/click-outside";
import "hjelseth-richeditor/dist/hjelseth-richeditor.css";
require("./bootstrap");

import { createApp, defineComponent, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import { createPinia } from "pinia";

// Setting up dayjs with norwegian locale
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import localeFormat from "dayjs/plugin/localizedFormat";
import nb from "dayjs/locale/nb";
import { Inertia } from "@inertiajs/inertia";
// @ts-ignore
import LevelsSelectList from "@/Components/General/LevelsSelect/LevelsSelectList.vue";
import LevelsSelect from "@/Components/General/LevelsSelect/LevelsSelect.vue";

dayjs.locale(nb);
dayjs.extend(localeFormat);
dayjs.extend(updateLocale);
dayjs.updateLocale("nb", {
  calendar: {
    lastDay: "[i går kl.] LT",
    sameDay: "[i dag kl.] LT",
    nextDay: "[i morgen kl.] LT",
    lastWeek: "[forrige] dddd [kl.] LT",
    nextWeek: "dddd [kl.] LT",
    sameElse: "L",
  },
});

createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),
  setup({ el, app, props, plugin }) {
    createApp({ render: () => h(app, props) })
      .use(plugin)
      .use(createPinia())
        .directive("click-outside", ClickOutside)
        .component("levels-select-list", LevelsSelectList)
        .component("levels-select", LevelsSelect)

        .mixin(defineComponent({ methods: { route } }))
      .mount(el);
  },
});

InertiaProgress.init({
  color: "#77ddaa",
});

// @ts-ignore
if (module.hot) {
  const firstVisit = window.location.pathname;
  // @ts-ignore
  module.hot.accept();
  // @ts-ignore
  module.hot.dispose(() => {
    if (firstVisit !== window.location.pathname) {
      window.location.reload();
    }
  });
}

// The below code ensures that data on the page is updated when clicking back button in browser.
let stale = false;

window.addEventListener("popstate", () => {
  stale = true;
});

Inertia.on("navigate", (event) => {
  const page = event.detail.page;
  if (stale) {
    Inertia.get(
      page.url,
      {},
      { replace: true, preserveState: false, preserveScroll: true }
    );
  }
  stale = false;
});
